import { cn } from '@utils/cn';
import { cva } from 'class-variance-authority';

const closeAnimation = cn(
  'data-[state=closed]:animate-out',
  'data-[state=closed]:fade-out-0',
  'data-[state=closed]:zoom-out-95',
  'data-[state=closed]:slide-out-to-left-1/2',
  'data-[state=closed]:slide-out-to-top-[48%]',
);

const openAnimation = cn(
  'data-[state=open]:animate-in',
  'data-[state=open]:fade-in-0',
  'data-[state=open]:zoom-in-95',
  'data-[state=open]:slide-in-from-left-1/2',
  'data-[state=open]:slide-in-from-top-[48%]',
);

const dialogVariants = cva(
  cn(
    'duration-200',
    'bg-background shadow-lg',
    'border sm:rounded-lg',
    'space-y-4 p-6',
    'fixed z-50 overflow-auto',
    'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
    'h-screen max-h-screen w-screen md:h-auto md:w-full md:max-w-lg',
    openAnimation,
    closeAnimation,
  ),
);

export { dialogVariants };
